/**
 * Get the ID from the Notion database from the given `urlString`.
 *
 * @example
 * parseDatabaseUrl('https://www.notion.so/someUser/abc123?v=xyz456')
 * // Returns `abc123`
 */
export function parseDatabaseUrl(urlString: string): string {
  const url = new URL(urlString)
  const pathname = url.pathname // After the domain, before the query string.
  const parts = pathname.split('/')
  return parts[parts.length - 1] // After any slashes.
}
